<!-- eslint-disable -->
<template>
	<div class="register-by-email"
		:style="removeBgbyWindowSize"		
		>
		<div class="bar"
			:style="{
				'background': colors.primary
			}"		
		></div>
		<BackLink></BackLink>
		<div class="disable_area_while_crating_account" v-if="!loaderInfo.show">
			<form-default
				v-if="!isRegistered"
				:contentTitle="$t('views.RegisterByEmail.contentTitle')"
				:titleLogin="$t('views.RegisterByEmail.titleLogin')"
				:inputs="inputs"
				:button="button"
			></form-default>
			<register-success v-if="isRegistered" ></register-success>
			<alert-error
				:textError="messageErrorRegister"
				:nameButton="buttonText"
				action="errorRegister"
				v-if="errorRegisterModal"
			></alert-error>
		</div>
		<default-loader
			:loaderMessage="loaderInfo.loaderMessage"
			:loaderStyle="loaderInfo.loaderStyle"
			v-show="loaderInfo.show"
		></default-loader>
	</div>
</template>
<script>
/* eslint-disable */
import FormDefault from "../../components/Forms/FormDefault";
import RegisterSuccess from "../../views/login/RegisterSuccess";
import AlertError from "../../components/Alerts/AlertError";
import ButtonOutline from "../../components/Buttons/ButtonOutline";
import BackLink from "../../components/Buttons/BackLink";
import Loader from "../../components/Alerts/Loader";
import Bus from "@/main.js";
import firebase from "firebase";
import api from "../../api/authentication.js";
import flowApi from "../../api/flowApi"
import createProcess from "../../helpers/createProcess"
export default {
	components: {
		FormDefault,
		RegisterSuccess,
		AlertError,
		ButtonOutline,
		BackLink,
		"default-loader": Loader
	},
	data() {
		return {
			buttonText: "",
			isRegistered: false,
			errorRegisterModal: false,
			inputs: [
				{
					placeholder: this.$t("views.RegisterByEmail.inputsPlaceholder[0]"),
					type: "text",
					name: "nome"
				},
				{
					placeholder: this.$t("views.RegisterByEmail.inputsPlaceholder[1]"),
					type: "text",
					name: "cpf"
				},
				{
					placeholder: this.$t("views.RegisterByEmail.inputsPlaceholder[2]"),
					type: "e-mail",
					name: "email"
				},
				{
					placeholder: this.$t("views.RegisterByEmail.inputsPlaceholder[3]"),
					type: "e-mail",
					name: "confirmEmail"
				},
				{
					placeholder: this.$t("views.RegisterByEmail.inputsPlaceholder[4]"),
					type: "password",
					name: "password"
				},
				{
					placeholder: this.$t("views.RegisterByEmail.inputsPlaceholder[5]"),
					type: "password",
					name: "confirmPass"
				}
			],
			button: {
				name: this.$t("views.RegisterByEmail.button"),
				typeLogin: "email",
				action: "createUserByEmail"
			},
			messageErrorRegister: "",
			buttonText: "",
			resetPassword: false,
			focusPassword: false,
			loaderInfo: {
				loaderMessage: "",
				loaderStyle: "",
				show: false
			},
			values: {},
			noCpfWorkspaces: ["jT52AjNtPZAlu2w9I8sm", "0Pu5gNwUQ4em7OQFymsl", "I7JQUZYr0tlZtHcJwcYj", "vbMmzuu4O1H1SYigjRHv", "ZsDMyr2nRWwTIcGidoxR","ObMLoJYLqUvEVP1Iua3g", "ngE29h7hsXLRYDA8GYpy", "ObMLoJYLqUvEVP1Iua3g"],
      		workspaceId: localStorage.getItem('workspaceId'),
			customFields: []
		};
	},
	async created() {
    	this.colors = JSON.parse(localStorage.getItem("colors"));
		this.game = localStorage.getItem("game-redirect");		
		Bus.$on("createUserByEmail", this.registerByEmail);
		Bus.$on("errorRegister", this.errorRegister);
		if(this.noCpfWorkspaces.includes(this.workspaceId)){
			let inputsWithoutCPF = this.inputs.filter(input => input.name !== 'cpf');
			this.inputs = inputsWithoutCPF 
		}
		this.customFields = this.$store.getters.getCustomFields(this.workspaceId)
		if(this.customFields && Array.isArray(this.customFields.fields)) for (const input of this.customFields.fields) this.inputs.push(input)
		// console.log(this.customFields)
			
	},
	destroyed() {
		Bus.$off("createUserByEmail", this.registerByEmail);
		Bus.$off("errorRegister", this.errorRegister);
	},
	// mounted() {
	// 	let inputs = document.querySelectorAll("input");
	// 	inputs[0].style.display = "none";
	// },	
	computed: {
		removeBgbyWindowSize(){
			const nobg = {
				'background':`linear-gradient(180deg, ${this.colors[this.colors.theme].from} 0%,  ${this.colors[this.colors.theme].to} 100%)`
			}
			const bg = {
				'background':`url(/img/background-${this.colors.theme}.png), linear-gradient(180deg, ${this.colors[this.colors.theme].from} 0%,  ${this.colors[this.colors.theme].to} 100%)`
			}
			return window.outerWidth >= 720 ? nobg : bg
		}		
	},	
	methods: {
		errorRegister() {
			if (this.resetPassword) {
				password.value = "";
				confirmPass.value = "";
			}

			this.focusPassword == true ? password.focus() : email.focus();
			this.errorRegisterModal = false;
		},
		async registerByEmail() {
			let self = this;
			const emails = await this.verifyData(email.value, confirmEmail.value);
			const passwords = await this.verifyData(password.value, confirmPass.value);
			const inputs = await this.verifyInput();
			if (!emails) {
				self.messageErrorRegister = self.$t("views.RegisterByEmail.messagesError[0].message");
				self.buttonText = self.$t("views.RegisterByEmail.messagesError[0].buttonText");
				self.errorRegisterModal = true;
				return
			}
			if (!passwords) {
				self.messageErrorRegister = self.$t("views.RegisterByEmail.messagesError[1].message");
				self.buttonText = self.$t("views.RegisterByEmail.messagesError[1].buttonText");
				self.errorRegisterModal = true;
				self.focusPassword = true;
				return
			}
			if (!inputs) {
				self.messageErrorRegister = self.$t("views.RegisterByEmail.messagesError[2].message");
				self.buttonText = self.$t("views.RegisterByEmail.messagesError[2].buttonText");
				self.errorRegisterModal = true;
				return
			} 
			if(this.customFields){
				this.customFields.info.graduationCourse = document.getElementById("graduationCourse").value
				this.customFields.info.graduationEndDate = document.getElementById("graduationEndDate").value
				// if (!this.verifyCustomFields()) {
				// 	this.messageErrorRegister = "Preencha todos os campos para realizar o seu cadastro";
				// 	this.buttonText = "Entendi";
				// 	this.errorRegisterModal = true;
				// 	return
				// }
				if(!this.isValidMaskedDate(this.customFields.info.graduationEndDate)){
					this.messageErrorRegister = "Data de graduação inválida";
					this.buttonText = "Entendi";
					this.errorRegisterModal = true;
					return	
				}
				this.customFields.workspaceId = this.workspaceId
				// console.log("this.customFields: ", this.customFields)
			}			
			this.showLoader(this.$t("views.RegisterByEmail.loader"), "circle");
			let input = document.querySelectorAll("input");
			let name = input[0].value;
			let cpfValue = input[1].value;
			cpfValue = cpfValue.replace(/\./g, "");
			cpfValue = cpfValue.replace(/\-/g, "");	
			try {
				let user = {
					name,
					password: password.value,
					cpf: cpfValue,
					email: email.value,
					// email: email.value.replaceAll(" ", "").toLowerCase(),
					newUser: true
				}
				const userResponse = await api.post("/users", user)
				// console.log("userResponse: ", userResponse.data)
				user.id = userResponse.data.fields.id
				user.token = userResponse.data.token
				delete user.password
				delete user.newUser
				if(this.customFields) {
					let info = this.customFields
					delete info.fields
					info.userId = user.id
					const addInfosResponse = await api.patch("/user-infos/add-workspace-info", info)
					// console.log("addInfosResponse: ", addInfosResponse)
				}
				const redirectGame = await localStorage.getItem('game-redirect')
				localStorage.setItem("user", JSON.stringify(user))
				localStorage.setItem("token", user.token)

				if(redirectGame !== 'repense' && redirectGame !== 'decode') await createProcess(user.id, localStorage.getItem('workspaceId'), user.name)
				self.hideLoader();
				self.isRegistered = true;
			} catch (error) {
				this.hideLoader();
				//TODO: make a error message showing up instead console.log error
				// console.log("error: ", error)
				if (error.response.data.response == "email already registered") {
					this.messageErrorRegister = this.$t("views.RegisterByEmail.messagesError[5].message");
					this.buttonText = this.$t("views.RegisterByEmail.messagesError[5].buttonText");
					this.errorRegisterModal = true;
					return
				} 
				if (error.response.data.response == "auth/weak-password") {
					this.messageErrorRegister = this.$t("views.RegisterByEmail.messagesError[3].message");
					this.buttonText = this.$t("views.RegisterByEmail.messagesError[3].buttonText");
					this.focusPassword = true;
					return this.errorRegisterModal = true;
				}
				if (error.response.data.response == "auth/invalid-email") {
					this.messageErrorRegister = this.$t("views.RegisterByEmail.messagesError[4].message");
					this.buttonText = this.$t("views.RegisterByEmail.messagesError[4].buttonText");
					return this.errorRegisterModal = true;
				}
				this.messageErrorRegister = "Houve um problema com o seu cadastro. Preencha todos os campos.";
				this.buttonText = "Tentar novamente";
				this.errorRegisterModal = true;
			}
		},
		verifyData(original, copia) {
			return original == copia ?  true : false;
		},
		verifyInput() {
			if (
				email.value == "" ||
				nome.value == "" ||
				confirmEmail.value == "" ||
				password.value == "" ||
				confirmPass.value == ""
			) {return false}
			return true;
		},
		verifyCustomFields(){
			// console.log("this.customFields: ", this.customFields)
			if(Object.keys(this.customFields.info).length == 0 
				|| Object.keys(this.customFields.info).length != this.customFields.fields.length) return false
			for (const inputValue in this.customFields.info) if(!this.customFields.info [inputValue]) return false
			return true
		},
		isValidMaskedDate(date){
			const dateSplitted = date.split("/")
			const currentDate = new Date().toISOString().split("T")[0].split("-").reverse()
			// if(
			// 	dateSplitted[dateSplitted.length - 2] < "01" || 
			// 	dateSplitted[dateSplitted.length - 2] > "12" || 
			// 	dateSplitted[dateSplitted.length - 1] < currentDate[2]
			// )return false
			// if(
			// 	currentDate[2] == 
			// 	dateSplitted[dateSplitted.length-1] && 
			// 	Number(dateSplitted[dateSplitted.length-2]) <= 
			// 	Number(currentDate[1])
			// )return false
			//Bloco comentado acima, verifica se mes/ano atual com o valor inserido(formato ##/### ou ##/##/###) 
			if(dateSplitted[dateSplitted.length - 2] < "01" || dateSplitted[dateSplitted.length - 2] > "12" ) return false
			return true
		},
		showLoader(message, style) {
			let self = this;
			self.loaderInfo.loaderMessage = message;
			self.loaderInfo.loaderStyle = style;
			self.loaderInfo.show = true;
		},
		hideLoader() {
			this.loaderInfo.show = false;
		}
	}
};
</script>
<style lang="scss" scoped>
.form-default {
	min-height: calc(80vh - 145px);
}
.register-by-email {
	min-height: calc(100vh - 110px);
	background-size: cover !important;
  .disable_area_while_crating_account{
		height: calc(96vh - 64px)
	}
  .bar{
		height: 2vh;
	}	
}
.container-button {
	.button-outline {
		display: flex;
		width: 100%;
		justify-content: center;
		border: none;
	}

	width: 100%;
	border-bottom: 1px solid #c2be5a;
	-webkit-box-shadow: 0px 6px 5px 0px rgba(230, 230, 230, 1);
	-moz-box-shadow: 0px 6px 5px 0px rgba(230, 230, 230, 1);
	box-shadow: 0px 6px 5px 0px rgba(230, 230, 230, 1);
	margin-top: 8%;

	.login-button {
		background-color: #fbf872;
		width: 100%;
		border: none;
		padding: 10px 0 15px;
		letter-spacing: 3px;
		text-transform: uppercase;
		font-weight: bold;
		font-size: 15px;
		color: #30353a;
		border-top: 7px #fbf872 solid;
		border-bottom: 7px #d8d365 solid;
		outline: none;
	}

	.button-action-start {
		padding: 15px 0 10px;
		border-top: 7px white solid;
		border-bottom: 7px #fbf872 solid;
	}

	.button-actions-finish {
		padding: 10px 0 15px;
		border-top: 7px #fbf872 solid;
		border-bottom: 7px #d8d365 solid;
	}
}
.loader {
	position: fixed;
	width: 100%;
	top: 0;
	background-color: #fffffff5;
}
</style>
